export default __webpack_public_path__ + "static/media/eldred_thumb500px.36f5a248.jpg";